module.exports = __webpack_public_path__ + "img/select2.b0e9f076.png";